import React, { FC } from "react";

import classnames from "classnames";

import { StyledOverlay } from "./Styles";

export interface IOverlay {
  disableBackgroundColor?: boolean;
}

export const Overlay: FC<
  IOverlay & Omit<React.ComponentPropsWithoutRef<"div">, keyof IOverlay>
> = ({ className, disableBackgroundColor = false, ...rest }) => {
  return (
    <StyledOverlay
      className={classnames("c-overlay", className)}
      $disableBackgroundColor={disableBackgroundColor}
      {...rest}
    />
  );
};

Overlay.displayName = "Overlay";
